import i18next from 'i18next';

const NBSP = String.fromCharCode(160);

export default function initI18n() {
  i18next.addResourceBundle('en', 'bot-ui', {
    addAiModel: 'Add AI Model',
    searchCatalog: 'Search catalog',
    providerModel: 'Provider model',
    providerModelCount: 'Provider model ({{count}})',
    updateNoFieldsChanged: 'No fields changed.',
    updateAiModel: 'Update from the Web',
    nbsp: NBSP,
    openRouterLabel: `OpenRouter${NBSP}`,
    bytePlusLabel: `BytePlus${NBSP}`,
    zaiLabel: `Z.ai${NBSP}`,
    docsBotLabel: `DocsBot${NBSP}`,
    analysisLabel: `Analysis${NBSP}`,
    openAiLabel: `OpenAI${NBSP}`,
    priceLabel: '· Price:',
    releasedLabel: '· Released:',
    featuresLabel: '· Features:',
    aiModelNotFound: 'AI model not found',
    aiModelDisabled: 'This AI model is disabled',
    openInEditor: 'Open in editor',
    replaceModel: 'Replace model',
    replaceAiModel: 'Replace AI model',
    deleteAiModel: 'Delete AI model',
    aiModels: 'AI Models',
    modelScores: 'Model Scores',
    allUseCases: 'All',
    showDisabledModels: 'Show disabled models',
    editDescription: 'Edit Description',
    saveDescription: 'Save Description',
    aiTools: 'AI Tools',
    deleteSelectedBots: 'Delete selected bots',
    editBot: 'Edit bot',
    deleteBot: 'Delete bot',
    autoStartEnabled: 'Auto start enabled',
    privateBot: 'Private',
    analysisSchemaExists: 'Analysis schema set',
    toolAccessMode: 'Tool access',
    allowToolsToWrite: 'Allow tools to write',
    outputSchemaExists: 'Output schema set',
    chooseABotForThisConvo: 'Choose a bot for this convo',
    newBot: 'New bot',
    newFolder: 'New folder',
    editPrompt: 'Edit prompt',
    removePromptFromBot: 'Remove prompt from bot',
    dragPromptsHereFromSidebar: 'Drag prompts here from the Prompts sidebar on the right.',
    showIdentical: 'Show identical',
    updatedAtLocal: 'Updated at local ({{env}})',
    updatedAtRemote: 'Updated at remote ({{env}})',
    deleteLocal: 'Delete local',
    deleteRemote: 'Delete remote',
    copyRemoteToLocal: 'Copy remote to local',
    copyLocalToRemote: 'Copy local to remote',
    compareObjects: 'Compare Objects',
    compareBots: 'Compare Bots',
    compareBotsWithPrev: 'Compare Bots with Prev',
    invalidGitChangesArtifactContent: 'Invalid git changes artifact content',
    workspaceFilesystemNotAvailable: 'Workspace filesystem is not available on this host.',
    diffOutputTruncated: 'Diff output was truncated because it exceeds the size limit.',
    changedFilesNoDiffHunks: 'Changed files detected, but no diff hunks were returned.',
    noDiffHunksForFile: 'No diff hunks for this file.',
    noInstructions: 'No instructions',
    editIcon: 'Edit icon',
    deleteMcpServer: 'Delete MCP server',
    mcpServers: 'MCP Servers',
    editText: 'Edit Text',
    saveText: 'Save Text',
    versionHistory: 'Version history',
    deleteSelectedPrompts: 'Delete selected prompts',
    deletePrompt: 'Delete prompt',
    invalidPromptVersionArtifactContent: 'Invalid prompt version artifact content',
    versionNotFoundForPrompt: 'Version {{version}} not found for prompt {{promptId}}.',
    noSavedVersionsYet: 'No saved versions yet.',
    newPrompt: 'New prompt',
    systemPromptPlaceholder: 'Enter a system prompt and apply markdown formatting if desired...',
    deterministicLabel: `0${NBSP}${NBSP}Deterministic/repetitive`,
    creativeLabel: `Random/creative${NBSP}${NBSP}2`,
    inputTokensLabel: 'Input tokens:',
    outputTokensLabel: 'Output tokens:',
    prices: 'Prices',
    priceTier: 'Tier',
    priceOverTokens: 'Over tokens',
    priceIn: 'In',
    priceCached: 'Cache read',
    priceCacheWrite: 'Cache write',
    priceOut: 'Out',
    priceAudioIn: `${NBSP}Audio in`,
    priceAudioMin: 'Audio min',
    priceTierFloorUnique: 'Tier and over tokens must be unique.',
    delete: 'Delete',
    cancel: 'Cancel',
    update: 'Update',
    deleteConfirmDescription:
      'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
    deleteAiModelConfirmDescription:
      'Delete "{{integration}}/{{modelName}}" from the AI model catalog? This cannot be undone.',
    aiModelDeleted: 'AI model deleted',
    aiModelHasConvos: 'A model with convos can’t be deleted',
    aiModelDisabledSnack: 'AI model disabled',
    aiModelEnabledSnack: 'AI model enabled',
    enableAiModel: 'Enable AI model',
    disableAiModel: 'Disable AI model',
    replacementModel: 'Replacement model',
    replaceModelConfirmDescription:
      'Replace "{{integration}}/{{modelName}}" on {{count}} {{noun}}. Select the new model.',
    botsUpdatedToModel: '{{count}} {{noun}} updated to {{integration}}/{{modelId}}',
    aiToolDescriptionsCodeDefined:
      'AI tool descriptions are defined in code and cannot be modified',
    failedToUpdateDescription: 'Failed to update description',
    botDeleted: 'Bot deleted',
    botNounSingular: 'Bot',
    botNounPlural: 'Bots',
    actionCannotBeUndoneSuffix: ' This action cannot be undone.',
    countNounDeleted: '{{count}} {{noun}} deleted',
    countNounUpdatedToModelName: '{{count}} {{noun}} updated to {{modelName}}',
    botPromptCreated: 'Bot prompt created',
    deleteItemQuestion: 'Delete {{noun}}?',
    deleteItemPermanentDescription:
      'This will permanently delete the {{noun}}. This action can’t be undone.',
    botSentToTrash: 'Bot sent to trash',
    botTrashFailed: 'Could not trash the bot',
    botRestoreFailed: 'Could not restore the bot',
    botRenamed: 'Bot renamed',
    newBotCreated: 'New bot created',
    newLabelCreated: 'New label created',
    promptRemoved: 'Prompt removed',
    promptUpdated: 'Prompt updated',
    deleteMcpServerConfirmDescription:
      'Are you sure you want to delete "{{name}}"? Bot bindings for this server will also be removed.',
    mcpServerDeleted: 'MCP server deleted',
    mcpServerUpdated: 'MCP server updated',
    textUpdatedSuccessfully: 'Text updated successfully',
    promptDeleted: 'Prompt deleted',
    promptNounSingular: 'Prompt',
    promptNounPlural: 'Prompts',
    promptRenamed: 'Prompt renamed',
    promptRestoreFailed: 'Could not restore the prompt',
    restoredVersion: 'Restored version {{version}}',
    newPromptCreated: 'New prompt created',
    syncDatabaseConfirmDescription:
      'Are you sure you want to sync the database from {{source}}? This will overwrite existing configurations.',
    cacheWriteLabel: 'Cache write:',
    auto: 'Auto',
    useCase: 'Use case',
    noModelForUseCase: 'No enabled model serves use case {{useCase}}.',
    updateAll: 'Update all',
    updateAllDescription: 'Refresh public scores for every enabled model.',
    score: 'Score',
    cursorBench: 'CursorBench',
    cursorBenchAbbrev: 'Cursr',
    intelligence: 'Intelligence',
    intelligenceAbbrev: 'Intel',
    coding: 'Coding',
    codingAbbrev: 'Coding',
    agentic: 'Agentic',
    agenticAbbrev: 'Agent',
    longContext: 'Long context',
    longContextAbbrev: 'Long',
    gpqa: 'GPQA',
    model: 'Model',
    effort: 'Effort',
    useCases: 'Use cases',
    costPerTask: '$/task',
    tokensPerTask: 'Tok/task',
    steps: 'Steps',
    tokensPerSecond: 'Tok/s',
    inDollarsPerMillion: 'In $/M',
    outDollarsPerMillion: 'Out $/M',
    plan: 'Plan',
    planSubscription: 'Subscription',
    planPayPerToken: 'Pay per token',
    integration: 'Integration',
    benchmarkSlug: 'Benchmark slug',
    benchmarkModel: 'Benchmark model',
    updated: 'Updated',
    columnId: 'ID',
    save: 'Save',
    edit: 'Edit',
    openArtificialAnalysis: 'Open Artificial Analysis',
    openEpoch: 'Open Epoch AI',
    modelScoreRefreshResult: '{{models}} models, {{scoreRows}} score rows, unmatched {{unmatched}}',
    noUnmatchedModels: 'none',
    modelScoresBy: 'Scores by',
    modelScoresAnd: 'and',
    modelScoresLicense: '(CC BY 4.0)',
    pairsHaveNoCostOrScore: '{{count}} pairs have no cost or score',
    untaggedModel: '{{modelName}} (untagged)',
    cursorBenchEpoch: 'CursorBench (Epoch)',
    costPerTaskEpoch: '$/task (Epoch)',
    tokensPerTaskEpoch: 'Tok/task (Epoch)',
    stepsEpoch: 'Steps (Epoch)',
    gpqaEpoch: 'GPQA (Epoch)',
    intelligenceArtificialAnalysis: 'Intelligence (Artificial Analysis)',
    codingArtificialAnalysis: 'Coding (Artificial Analysis)',
    agenticArtificialAnalysis: 'Agentic (Artificial Analysis)',
    longContextArtificialAnalysis: 'Long context (Artificial Analysis)',
    tokensPerSecondArtificialAnalysis: 'Tok/s (Artificial Analysis)',
  });
}
